/** @deprecated Prefer DFC's built-in `loading`, `error`, and `data` fields. */
export const UNINITIALIZED = 'UNINITIALIZED';
/** @deprecated Prefer DFC's built-in `loading`, `error`, and `data` fields. */
export const PENDING = 'PENDING';
/** @deprecated Prefer DFC's built-in `loading`, `error`, and `data` fields. */
export const SUCCEEDED = 'SUCCEEDED';
/** @deprecated Prefer DFC's built-in `loading`, `error`, and `data` fields. */
export const FAILED = 'FAILED';